import { render, staticRenderFns } from "./OpportunityResourceView.vue?vue&type=template&id=5ae9849b&"
import script from "./OpportunityResourceView.vue?vue&type=script&lang=js&"
export * from "./OpportunityResourceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports